<template>
  <footer class="footer">
    <div class="main">
      <div class="footer-container">
      <!-- 左侧 Logo 和公司名称 -->
      <div class="footer-left"  :class="currentLanguage">
        <img src="@/assets/home/logo@.png" alt="苏润人才" class="footer-logo">
        <div class="company-names">
          <p>{{ $t('nav.company.surun') }}</p>
          <p>{{ $t('nav.company.running') }}</p>
          <p>{{ $t('nav.company.runjiang') }}</p>
          <p>{{ $t('nav.company.runtong') }}</p>
          <p>{{ $t('nav.company.runan') }}</p>
        </div>
      </div>

      <!-- 右侧导航链接 -->
      <div class="footer-right">
        <!-- 集团概括 -->
        <div class="footer-section footer-section1">
          <h3>{{ $t('nav.title.tro') }}</h3>
          <ul class="group-links">
            <li>
              <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('intro')"
                >
                  {{ $t('nav.group.intro') }}
                </router-link></li>
            <li>
              <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('members')"
                >
                  {{ $t('nav.group.members') }}
                </router-link>
            </li>
            <li>
                <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('culture')"
                >
                  {{ $t('nav.group.culture') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('products')"
                >
                  {{ $t('nav.group.products') }}
                </router-link>
              </li>
              <!-- <li>
                <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('history')"
                >
                  {{ $t('nav.group.history') }}
                </router-link>
              </li> -->
              <!-- <li>
                <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('honors')"
                >
                  {{ $t('nav.group.honors') }}
                </router-link>
              </li> -->
              <!-- <li>
                <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('partners')"
                >
                  {{ $t('nav.group.partners') }}
                </router-link>
              </li> -->
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('contact')"
                >
                  {{ $t('nav.group.contact') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link"
                  @click.native="scrollToSection('join')"
                >
                  {{ $t('nav.group.join') }}
                </router-link>
              </li>
          </ul>
        </div>

        <!-- 友情链接 -->
        <div class="footer-section footer-section2">
          <h3>{{ $t('nav.title.link') }}</h3>
          <ul>
            <li v-for="link in friendlyLinks" :key="link.id">
              <a :href="link.url" target="_blank">{{ link.title }}</a>
            </li>
          </ul>
        </div>

        <!-- 联系我们 -->
        <div class="footer-section footer-section3">
          <h3>{{ $t('nav.title.contact') }}</h3>
          <ul class="contact-info">
            <li>
              <span>{{ $t('nav.contact.phone') }}：</span>
              <a :href="`tel:${companyInfo.phone}`">{{ companyInfo.phone }}</a>
            </li>
            <li>
              <span>{{ $t('nav.contact.email') }}：</span>
              <a :href="`mailto:${companyInfo.mail}`">{{ companyInfo.mail }}</a>
            </li>
            <li>
              <span>{{ $t('nav.contact.location') }}：</span>
              <p v-if="en">{{ companyInfo.locationen }}</p>
              <p v-else>{{ companyInfo.location }}</p>
            </li>
          </ul>
          <!-- <div class="qrcode-section">
            <p>{{ $t('nav.contact.sao') }}</p>
           <div class="qrcode-container">
              <div class="qrcode-item">
                <img :src="companyInfo.url" alt="微信二维码">
                <img v-if="companyInfo.url2" :src="companyInfo.url2" alt="微信二维码">
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="footer-tubiao">
      <a @mouseover="showPopup('wechat')" @mouseleave="hidePopup('wechat')">
        <img class="footer-tubiao-item" src="@/assets/home/weiixn.png" alt="">
        <div v-show="popups.wechat" class="popup">
          <img :src="companyInfo.url" alt="微信图片1">
          <img v-if="companyInfo.url2" :src="companyInfo.url2" alt="微信图片2">
        </div>
      </a>
      <a @mouseover="showPopup('xiaohongshu')" @mouseleave="hidePopup('xiaohongshu')">
        <img class="footer-tubiao-item" src="@/assets/home/xiaohongshu.png" alt="">
        <div v-show="popups.xiaohongshu" class="popup">
          <img :src="companyInfo.red1" alt="小红书图片1">
          <img v-if="companyInfo.red2" :src="companyInfo.red2" alt="小红书图片2">
        </div>
      </a>
      <a @mouseover="showPopup('douyin')" @mouseleave="hidePopup('douyin')">
        <img class="footer-tubiao-item" src="@/assets/home/douyin.png" alt="">
        <div v-show="popups.douyin" class="popup">
          <img :src="companyInfo.tk1" alt="抖音图片1">
          <img v-if="companyInfo.tk2" :src="companyInfo.tk2" alt="抖音图片2">
        </div>
      </a>
      <a :href="`${companyInfo.link}`"  target="_blank"><img class="footer-tubiao-item" src="@/assets/home/lingying.png" alt="">
      </a>
      <a :href="`${companyInfo.youtube}`"  target="_blank"><img class="footer-tubiao-item" src="@/assets/home/youtube.png" alt="">
      </a>
      <a :href="`${companyInfo.twitter}`"  target="_blank"><img class="footer-tubiao-item" src="@/assets/home/tuite.png" alt="">
      </a>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer-bottom">
      <p style="margin-bottom: 10px;">© {{ new Date().getFullYear() }} {{ $t('nav.copyright') }}</p>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号：苏ICP备2024148009号-1</a>
    </div>
    </div>
  </footer>
</template>

<script>
import { getFooterInfo, getFooterLinks } from '@/api/user'

export default {
  computed: {
    // 获取当前语言
    currentLanguage() {
      return this.$i18n.locale; // 假设你的 i18n 语言标识是 'zh' 或 'en'
    }
  },
  name: 'SiteFooter',
  data() {
    return {
      companyInfo: {},
      friendlyLinks: [],
      popups: {
        wechat: false,
        xiaohongshu: false,
        douyin: false,
      },
      en: false,
    }
  },
  created() {
    this.getFooterInfo()
    this.getFooterLinks()
    this.$watch('$i18n.locale', (newVal) => {
      console.log('Language changed to:', newVal)
      // 更新 Vant 组件语言
      if (newVal === 'en') {
        this.en = true
      } else {
        this.en = false
      }
    }, { immediate: true })
  },
  methods: {
    showPopup(popupName) {
      this.popups[popupName] = true;
    },
    hidePopup(popupName) {
      this.popups[popupName] = false;
    },

    async getFooterInfo() {
      try {
        const res = await getFooterInfo()
        this.companyInfo = res.data
      } catch (error) {
        console.error('获取底部信息失败:', error)
      }
    },
    async getFooterLinks() {
      try {
        const res = await getFooterLinks()
        this.friendlyLinks = res.data
      } catch (error) {
        console.error('获取底部链接失败:', error)
      }
    },
    scrollToSection(sectionId) {
      // 确保当前页面
      if (this.$route.path === '/group') {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      } else {
        // 如果不在当前页面，先跳转再滚动
        this.$router.push('/group').then(() => {
          this.$nextTick(() => {
            const element = document.getElementById(sectionId)
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' })
            }
          })
        })
      }
    },
  }
}
</script>

<style scoped>
.footer {
  background: #E3E8F2;
  padding: 30px 0 20px;
  border-top: 1px solid #EEEEEE;
}

.main {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between; /* 子元素之间的空间将均匀分配 */
}

.footer-left.zh {
  width: 25%;
  text-align: right;
  margin-right: 300px;
}

.footer-left.en {
  width: 35%;
  text-align: right;
  margin-right: 200px;
}

.footer-logo {
  width: 180px;
  height: auto;
  margin-bottom: 20px;
}

.company-names {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: right;
}

.company-names p {
  line-height: 29px;
}

.footer-right {
  width: 70%;
  display: flex;
  justify-content: space-between;
}

.footer-section {
  padding: 0 20px;
  text-align: left;
}

.footer-section1 {
  width: 26%;
  margin-top: 30px;
}

.footer-section2 {
  width: 30%;
  margin-top: 30px;
}

.footer-section3 {
  width: 40%;
  margin-top: 30px;
}

.footer-section h3 {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 20px;
}

.footer-section ul {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  margin: 0;
}

.footer-section li {
  list-style: none;
  white-space: normal;
  line-height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #787878;
  text-align: left;
  font-style: normal;
}

.footer-section a {
  text-decoration: none;
  font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #787878;
line-height: 20px;
text-align: left;
font-style: normal;
}

.footer-section a:hover {
  color: #3379F2;
}

.contact-info {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.contact-info li {
  display: flex;
  align-items: flex-start;
  white-space: normal !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #787878;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.contact-info span {
  flex-shrink: 0;
  margin-right: 5px;
}

.contact-info p {
  margin: 0;
  flex: 1;
}

.qrcode-section {
  margin-top: 10px;
  font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #787878;
line-height: 20px;
text-align: left;
font-style: normal;
}

.qrcode-container {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.qrcode-item {
  text-align: center;
  display: flex;
  gap: 10px;
}

.qrcode-item img {
  width: 100px;
  height: 100px;
  margin-bottom: 5px;
}

.qrcode-item p {
  font-size: 12px;
  color: #666666;
}

.footer-bottom {
  margin-top: 40px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #EEEEEE;
  color: #999999;
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }
  
  .footer-left {
    width: 100%;
    margin-bottom: 30px;
  }
  
  .footer-right {
    width: 100%;
    flex-direction: column;
  }
  
  .footer-section {
    margin-bottom: 30px;
    padding: 0;
  }
  
  .qrcode-container {
    justify-content: center;
  }



  .footer-tubiao-item {
    width: 48px;
    height: 48px;

  }
}

/* 添加或修改底部图标样式 */
.footer-tubiao {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  max-width: 1200px;
  margin: 50px auto 0;

}

a {
  position: relative;
  display: inline-block;
}

.footer-tubiao-item {
  width: 48px;
  height: 48px;
  transition: all 0.3s ease;

}

.footer-tubiao a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-tubiao-item:hover {
  transform: scale(1.1);
}

/* 特别处理集团概况的列表,保持原有的两列布局 */
.group-links {
  display: grid !important;
  grid-template-columns: repeat(1, 1fr) !important;
}

@media screen and (max-width: 1200px) {
  .main {
    padding: 0% 5%;
  }
}

.popup {
  position: absolute;
  /* bottom: 200%;  */
  background-color: #fff; /* Background color of the popup */
  bottom: 110%; 
  border-radius: 4px; /* Rounded corners */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Shadow for the popup */
  white-space: nowrap; /* Prevent text from wrapping */
  z-index: 10; /* Ensure the popup is above other content */
  /* Add additional styling as needed */
}

.popup img {
  width: 150px;
  height: 150px;
  padding: 10px;
}
</style> 
